import { useEffect } from 'react';

export default function useCanvasZoom(
    canvasInstance,
    bgCanvasInstance,
    zoom,
    onZoom,
    initMinZoom,
    canvasName
) {
    useEffect(() => {
        if (canvasInstance.current && zoom) {
            const canvas = canvasInstance.current;
            const bgCanvas = bgCanvasInstance?.current;

            const center = canvas.getCenter();
            canvas.zoomToPoint({ x: center.left, y: center.top }, zoom);
            if(bgCanvasInstance) bgCanvas.zoomToPoint({ x: center.left, y: center.top }, zoom);

            canvas.requestRenderAll();
        }
    }, [zoom]);

    const handleWheel = (opt) => {
        const canvas = canvasInstance.current;
        const bgCanvas = bgCanvasInstance?.current;
        const e = opt.e;
        if (!canvas || !e) return;

        e.preventDefault();

        const delta = e.deltaY > 0 ? -0.01 : 0.01;
        const currentZoom = canvas.getZoom();
        let newZoom = currentZoom + delta;
        if(newZoom < 0.01) return
        const center = canvas.getCenter();
        canvas.zoomToPoint({ x: center.left, y: center.top }, newZoom);
        if(bgCanvasInstance) {
            bgCanvas.zoomToPoint({ x: center.left, y: center.top }, newZoom)
            bgCanvas.requestRenderAll();
        }

        onZoom(newZoom, canvasName);

        canvas.requestRenderAll();
    };

    useEffect(() => {
        if (canvasInstance.current) {
            canvasInstance.current.on('mouse:wheel', handleWheel);
            return () => {
                canvasInstance.current.off('mouse:wheel', handleWheel);
            };
        }
    }, [onZoom]);
}
